export const GET_LIVES_REQUEST = 'GET_LIVES_REQUEST';
export const GET_LIVES_SUCCESS = 'GET_LIVES_SUCCESS';
export const GET_LIVES_FAILURE = 'GET_LIVES_FAILURE';

export const RESET_LIVES_NUMBER = 'RESET_LIVES_NUMBER';
export const SET_NEW_LIFE_TIMER = 'SET_NEW_LIFE_TIMER';
export const CLEAR_NEW_LIFE_TIMER = 'CLEAR_NEW_LIFE_TIMER';
